
export default {
    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },
        bColor: {
            type: String,
            default: '',
        },
    },

    computed: {
        background() {
            return this.bColor ? `background-color: ${this.bColor}` : {}
        },
    },
}
